// extracted by mini-css-extract-plugin
export default {"topNav":"RP-z","category":"SP-z","noArrow":"TP-z","alternative":"UP-z","topLevelNavItem":"VP-z","navContainer":"WP-z","subcategoryHeading":"XP-z","subcategory":"YP-z"};